import React, { useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const validationSchema = yup.object().shape({});

export default function ConfirmacaoEnvioNota({ setOpenModalConfirmacao }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    setLoading(true);
    console.log(data);
  };

  return (
    <>
      {loading && <Loader />}
      <h2>Nova emissão de nota fiscal</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper elevation={3} style={{ padding: "20px", marginBottom: "20px" }}>
          <Typography variant="h6" gutterBottom>
            Geral
          </Typography>
          <Grid container className="form" spacing={2}>
            <Grid item xs={12} className="field">
              <label>Natureza da Operação</label>
              <input type="text" {...register("natureza_operacao")} />
              <span className="error">{errors.natureza_operacao?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Data de Emissão</label>
              <input type="datetime-local" {...register("data_emissao")} />
              <span className="error">{errors.data_emissao?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Tipo de Documento</label>
              <select {...register("tipo_documento")}>
                <option value="0">Nota Fiscal de Entrada</option>
                <option value="1">Nota Fiscal de Saída</option>
              </select>
              <span className="error">{errors.tipo_documento?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Local do Destino</label>
              <select {...register("local_destino")}>
                <option value="1">Operação interna</option>
                <option value="2">Operação interestadual</option>
                <option value="3">Operação com exterior</option>
              </select>
              <span className="error">{errors.local_destino?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Finalidade da Emissão</label>
              <select {...register("finalidade_emissao")}>
                <option value="1">Normal</option>
                <option value="2">Complementar</option>
                <option value="3">Nota de ajuste</option>
                <option value="4">Devolução</option>
              </select>
              <span className="error">
                {errors.finalidade_emissao?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Consumidor Final</label>
              <select {...register("consumidor_final")}>
                <option value="0">Normal</option>
                <option value="1">Consumidor final</option>
              </select>
              <span className="error">{errors.consumidor_final?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Presença do Comprador</label>
              <select {...register("presenca_comprador")}>
                <option value="0">Não se aplica</option>
                <option value="1">Operação presencial</option>
                <option value="2">
                  Operação não presencial, pela Internet
                </option>
                <option value="3">
                  Operação não presencial, Teleatendimento
                </option>
                <option value="4">
                  NFC-e em operação com entrega em domicílio
                </option>
                <option value="9">Operação não presencial, outros</option>
              </select>
              <span className="error">
                {errors.presenca_comprador?.message}
              </span>
            </Grid>
          </Grid>
        </Paper>
        <Paper elevation={3} style={{ padding: "20px", marginBottom: "20px" }}>
          <Typography variant="h6" gutterBottom>
            Emitente
          </Typography>
          <Grid container className="form" spacing={2}>
            <Grid item xs={6} className="field">
              <label>CNPJ</label>
              <input type="text" {...register("cnpj_emitente")} />
              <span className="error">{errors.cnpj_emitente?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>CPF</label>
              <input type="text" {...register("cpf_emitente")} />
              <span className="error">{errors.cpf_emitente?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Inscrição Estadual</label>
              <input type="text" {...register("inscricao_estadual_emitente")} />
              <span className="error">
                {errors.inscricao_estadual_emitente?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Logradouro</label>
              <input type="text" {...register("logradouro_emitente")} />
              <span className="error">
                {errors.logradouro_emitente?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Número</label>
              <input type="text" {...register("numero_emitente")} />
              <span className="error">{errors.numero_emitente?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Bairro</label>
              <input type="text" {...register("bairro_emitente")} />
              <span className="error">{errors.bairro_emitente?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Município</label>
              <input type="text" {...register("municipio_emitente")} />
              <span className="error">
                {errors.municipio_emitente?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>UF</label>
              <input type="text" {...register("uf_emitente")} />
              <span className="error">{errors.uf_emitente?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Regime Tributário</label>
              <select {...register("regime_tributario_emitente")}>
                <option value="1">Simples Nacional</option>
                <option value="2">
                  Simples Nacional – excesso de sublimite
                </option>
                <option value="3">Regime Normal</option>
              </select>
              <span className="error">
                {errors.regime_tributario_emitente?.message}
              </span>
            </Grid>
          </Grid>
        </Paper>
        <Paper elevation={3} style={{ padding: "20px", marginBottom: "20px" }}>
          <Typography variant="h6" gutterBottom>
            Destinatário
          </Typography>
          <Grid container className="form" spacing={2}>
            <Grid item xs={6} className="field">
              <label>Nome</label>
              <input type="text" {...register("nome_destinatario")} />
              <span className="error">{errors.nome_destinatario?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>CNPJ</label>
              <input type="text" {...register("cnpj_destinatario")} />
              <span className="error">{errors.cnpj_destinatario?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>CPF</label>
              <input type="text" {...register("cpf_destinatario")} />
              <span className="error">{errors.cpf_destinatario?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Inscrição Estadual</label>
              <input
                type="text"
                {...register("inscricao_estadual_destinatario")}
              />
              <span className="error">
                {errors.inscricao_estadual_destinatario?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Logradouro</label>
              <input type="text" {...register("logradouro_destinatario")} />
              <span className="error">
                {errors.logradouro_destinatario?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Número</label>
              <input type="text" {...register("numero_destinatario")} />
              <span className="error">
                {errors.numero_destinatario?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Bairro</label>
              <input type="text" {...register("bairro_destinatario")} />
              <span className="error">
                {errors.bairro_destinatario?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Município</label>
              <input type="text" {...register("municipio_destinatario")} />
              <span className="error">
                {errors.municipio_destinatario?.message}
              </span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>UF</label>
              <input type="text" {...register("uf_destinatario")} />
              <span className="error">{errors.uf_destinatario?.message}</span>
            </Grid>
            <Grid item xs={6} className="field">
              <label>Indicador Inscrição Estadual</label>
              <select
                {...register("indicador_inscricao_estadual_destinatario")}
              >
                <option value="1">Contribuinte ICMS</option>
                <option value="2">Contribuinte isento</option>
                <option value="9">Não Contribuinte</option>
              </select>
              <span className="error">
                {errors.indicador_inscricao_estadual_destinatario?.message}
              </span>
            </Grid>
          </Grid>
        </Paper>

        <div className="actions">
          <button type="submit" className="save">
            Emitir nota fiscal Eletrônica
          </button>
          <a
            href="#"
            className="cancel"
            onClick={() => setOpenModalConfirmacao(false)}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
